import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { createFormSchema, initialValues } from "./contants";

export function useAddUpdateEmployeeForm() {
  const {
    CorporateManagementEmployeeList: cr,
    CorporateGeneralErrorMessage: cre,
  } = useMobileContentResource();

  const schema = useMemo(() => {
    return createFormSchema(cr, cre);
  }, [cr, cre]);

  const methods = useForm({
    resolver: zodResolver(schema),
    defaultValues: initialValues,
    mode: "onSubmit",
    criteriaMode: "all",
    reValidateMode: "onChange",
    shouldFocusError: true,
  });

  return methods;
}
